import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, FieldArray, change } from 'redux-form';
import { Row, Col, Card, CardContent, Translate, Button, Icon, H2, FileButton, Image, Select, Modal, Input, Gallery, MediaPlayer } from '$common';
import { QuestionIconMap, QuestionTypeGroupMap } from '$constants/task-form';
import QuestionTypes from './question-types';
import CSSModules from 'react-css-modules';
import style from './task-form.scss';
import { groupBy, isEmpty } from 'lodash';



const GroupedQuestionTypes = groupBy(QuestionTypes, 'type');

let QuestionType = '';

let bulkOptions = [];

let FormField = props => {
  return (
    <div styleName="form-field">
      {
        props.type === 'checkbox' ?
          <div styleName="checkbox">
            <Field
              name={props.name}
              type={props.type}
              component="input"
            />
            <label htmlFor={props.name} styleName="label">{props.label}</label>
          </div>
        : 
        props.type === 'file' ? 
          <div>
            <Field
              name={props.name}
              type={props.type}
              onChange={props.onChange}
              component={props => {
                return(
                  <input
                    type={props.type}
                    className={props.className}
                    onChange={props.input.onChange}
                    multiple
                  />
                )
              }}
            />
          </div>
        : 
          <div>
            <label htmlFor={props.name}>{props.label}</label>
            <Field
              name={props.name}
              type={props.type || 'text'}
              component={props => {
                return(
                  <input
                    type={props.type}
                    placeholder={props.placeholder}
                    className={props.className}
                    defaultValue={props.input.value}
                    onBlur={props.input.onChange}
                  />
                )
              }}
              styleName="field"
              placeholder={props.placeholder || ''}
            />
          </div>
      }
    </div>
  )
};
FormField = CSSModules(FormField, style);

@CSSModules(style, { allowMultiple: true })
class Element extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addNewLogicalJump: false,
      jumpFrom: null
    }
  }

  get data() {
    const { questions, order } = this.props;
    return questions[order-1];
  }

  get element() {
    return GroupedQuestionTypes[this.data.question_type][0]
  }

  initializeQuestionType() {
    const { data, updateQuestion } = this.props;
    QuestionTypeGroupMap.map( (item, index) => {
      item.types.map( (type, index) => {
        if (this.data.question_type === type.type && !this.data.type_group_name) {
          updateQuestion(data, 'type_group_name',  item.group_name);
          updateQuestion(data, 'group_name', item.group_name);
          updateQuestion(data, 'type_name', type.type_name);
        }
      })
    })
  }

  initializeJumpId() {
    const { data, updateQuestion, order } = this.props;
    this.setState({
      addNewLogicalJump: false,
      jumpFrom: null
    });
    if (!this.data.jumpable_id) {
      updateQuestion(data, 'jumpable_id', order);
    }
    if (!this.data.active_jump) {
      updateQuestion(data, 'active_jump', [-1, -1]);
    }
  }

  initializeRangeQuestion() {
    if (this.data.question_type === 'range') {  
      if (this.data.question_options.length > 0 && typeof this.data.min === "undefined" && typeof this.data.max === "undefined" && typeof this.data.interval === "undefined" ) {
        this.data.min = parseInt(this.data.question_options[0].label);
        this.data.max = parseInt(this.data.question_options[this.data.question_options.length-1].label);
        this.data.interval = parseInt(this.data.question_options[1].label) - parseInt(this.data.question_options[0].label);
        this.data.min_label = this.data.question_options[0].optional_label;
        this.data.max_label = this.data.question_options[this.data.question_options.length-1].optional_label;
      }
    }
  }

  parseBulkOptions(val) {
    const lines = val.split('\n');
    bulkOptions = [];
    if (lines.length > 0) {
      lines.map(item => {
        bulkOptions.push({ jump_ids: [], label: item.split('|')[0], answer_points: 0 });
      });
    }
  }

  removeQuestion() {
    const { data, updateQuestion, questions } = this.props;
    updateQuestion(data, '_destroy', true);
    questions.map( (question, index) => {
      question.question_options.map( (option, optionIndex) => {
        option.jump_ids.map( (jump, jumpIndex) => {
          if (jump === this.data.jumpable_id) {
            option.jump_ids.splice(jumpIndex, 1)
            updateQuestion(`questions[${index}]`, `question_options[${optionIndex}]`, option)
          }
        })
      })
    })
  }

  addMediaToQuestion(file) {
    let media = this.data.media;

    if (file) {    
      if (file.type.indexOf('image') !== -1) {
        media.images.push(file);
      } else if(file.type.indexOf('audio') !== -1) {
        media.voice_records.push(file);
      } else if(file.type.indexOf('video') !== -1) {
        media.videos.push(file);
      }
      this.props.updateQuestion(this.props.data, 'media', media);
    }
  }

  openLightbox(media_type, media_index) {
    const currentMedia = URL.createObjectURL(this.data.media[media_type][media_index]);
    this.setState({
      lightboxIsOpen: true,
      media: [{ src: currentMedia }],
      customMedia: media_type !== 'images' ?
      <div style={{ width: '500px' }}>
        <MediaPlayer
          url={currentMedia}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
          }}
        />
      </div>
      : null
    })
  }

  componentWillMount() {
    if (this.data) {    
      this.initializeQuestionType();
      this.initializeJumpId();
      this.initializeRangeQuestion();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.data) {
      this.initializeQuestionType();
      this.initializeRangeQuestion();
    }
  }

  render() {
    const { order, data, questions, updateQuestion, duplicate, addNewElement, options } = this.props;

    if (this.data) {
      QuestionType = this.element;
    }

    return this.data ? (
      <div>
        <div styleName="element">
          <Card>
            <div styleName="section-title">
              <span styleName="order">{order}</span>
              <span styleName="content"><Icon name={QuestionIconMap[this.data.question_type]}/> {this.data.label}</span>
              <Button 
                type="weak"
                size="small"
                onClick={() => {
                    this.data.is_closed ?
                      updateQuestion(data, 'is_closed', false)
                    : 
                      updateQuestion(data, 'is_closed', true)
                  }
                }
                style={{ marginLeft: '5px' }}
              >
                {
                  !this.data.is_closed ? 
                    [
                      <Icon name="check" key={1}/>,
                      ` ${Translate.get('done')}`
                    ]
                  : 
                    [
                      <Icon name="pencil" key={0}/>,
                      ` ${Translate.get('edit')}`
                    ]
                }
              </Button>
              {duplicate}
              <Button   
                type="danger"
                size="small"
                onClick={() => confirm(Translate.get('are_you_sure')) ? this.removeQuestion() : null}
                style={{ marginLeft: '5px' }} id="live-question-delete-button"
              >
                <Icon name="trash" /> {Translate.get('delete')}
              </Button>
            </div>
            {
              !this.data.is_closed ?
                <CardContent style={{ padding: '15px' }}>
                  <span styleName="question-types">
                    {Translate.get('question_types')}
                  </span>
                  <div styleName="group-wrapper">
                    <Row>
                      {
                        QuestionTypeGroupMap.map( (item, index) => {
                          return(
                            <Col md="1/4" gutter={0} key={index}>
                              <div styleName="group">
                                {
                                  this.data.type_group_name ? 
                                    item.group_name === this.data.type_group_name ?
                                      <span styleName="name active">{this.data.type_name}</span>  
                                    : <span styleName="name">{item.group_name}</span>
                                  : <span styleName="name">{item.group_name}</span>
                                }
                                <ul>
                                  {
                                    item.types.map( (type, index) => {
                                      return(
                                        <li
                                          key={ index }
                                          onClick={ () => {
                                              updateQuestion(data, 'question_type',  type.type);
                                              updateQuestion(data, 'type_group_name',  item.group_name);
                                              updateQuestion(data, 'group_name', item.group_name);
                                              updateQuestion(data, 'type_name', type.type_name);
                                            } 
                                          }
                                          styleName={this.data.question_type === type.type ? 'active' : ''}
                                        >
                                          {type.type_name}
                                        </li>
                                      )
                                    })
                                  }
                                </ul>
                              </div>
                            </Col>
                          )
                        })
                      }
                    </Row>
                  </div>
                  <FormField name={`${data}.label`} label={Translate.get('question')}/>
                  <FormField name={`${data}.description`} label={Translate.get('enter_hint')}/>
                  {
                    this.data.question_type !== "information" ?
                      <FormField name={`${data}.is_required`} label={Translate.get('is_this_question_required')} type="checkbox"/>
                    : ''
                  }
                  <Row>
                    <Col md="2/12">
                      <H2 style={{ marginLeft: 0 }}><b>{Translate.get('media')}</b></H2>
                      <FileButton type="weak" onChange={::this.addMediaToQuestion}>{Translate.get('upload_media')}</FileButton>
                    </Col>
                    <Col md="10/12">
                      {
                        this.data.media ?
                          Object.keys(this.data.media).map( media_type => (
                            this.data.media[media_type].map( (media, index) => (media._destroy === undefined ) ? (
                              <div styleName="media-wrapper">
                                 <a styleName="media" style={media_type === 'voice_records' || media_type === 'videos' ? { width: '110px' } : null} onClick={() => this.openLightbox(media_type, index)}>
                                    <span styleName="delete-btn" onClick={() => {
                                      let media = this.data.media;
                                      media[media_type][index]._destroy = true;
                                      updateQuestion(data, 'media', media);
                                    }}>
                                     <Icon name="times"/>
                                    </span>
                                    {
                                      media_type === 'images' ?
                                        <Image
                                          source={typeof media.type !== "undefined" ? URL.createObjectURL(media) : ''}
                                          width="70"
                                          square
                                        />
                                      : null
                                    }
                                    {
                                      media_type === 'voice_records' || media_type === 'videos' ?
                                        <span styleName="play-media">
                                          <Icon name="play" />
                                        </span>
                                      : null
                                    }
                                 </a>
                              </div>
                            ) : '')
                          ))
                        : null
                      }
                    </Col>
                  </Row>
                  <br /><br />
                  {
                    this.element.optionable ?
                      <div>
                        <FieldArray name={`${data}.question_options`} component={options} questionIndex={order-1} addBulkOptions={() => updateQuestion(data, 'is_bulk_option_modal_open', true)} />
                        <Modal
                          size="small"
                          title={Translate.get('add_bulk_options')}
                          onCloseRequest={() => updateQuestion(data, 'is_bulk_option_modal_open', false)}
                          isOpen={this.data.is_bulk_option_modal_open}>
                          <Row>
                            <Col>
                              <Input type="text" rows="6" placeholder={`each line will be an option`} onBlur={e => this.parseBulkOptions(e.target.value)}/>
                              <Button onClick={() => {
                                updateQuestion(data, 'question_options', bulkOptions);
                                updateQuestion(data, 'is_bulk_option_modal_open', false);
                              }} block>{Translate.get('save_changes')}</Button>
                            </Col>
                          </Row>
                        </Modal>
                        <br /><br />
                        {
                          questions.length > 1 && order !== questions.length ?
                            <div>
                              <H2 style={{ marginLeft: 0 }}><b>{Translate.get('logical_jumps')}</b></H2>
                              {
                                this.data.question_options.map( (option, index) => (
                                  option.jump_ids.map( (jump, jumpIndex) => {
                                    if (this.data.active_jump) {
                                      if (index === this.data.active_jump[0] && jumpIndex === this.data.active_jump[1]) {
                                        return(
                                          <div styleName="jump-form" key={index}>
                                            <div styleName="form-content">
                                              {Translate.get('answer_equals_to')}
                                              <span styleName="badge">{option.label}</span>
                                              {Translate.get('jump_to_question')}
                                              <Select
                                                options={questions.map((question, index) => (
                                                  { label: `${index+1} - ${question.label}`, value: question.jumpable_id, disabled: index <= order - 1 }
                                                ))}
                                                onChange={val => {
                                                  if (val !== jump) {
                                                    this.data.question_options[index].jump_ids[jumpIndex] = val;
                                                    updateQuestion(data, `question_options[${index}].jump_ids`, this.data.question_options[index].jump_ids);
                                                    updateQuestion(data, 'active_jump', [-1, -1]);
                                                  }
                                                }}
                                                value={jump}
                                                id="inline-select"
                                              />
                                            </div>
                                          </div>
                                        )
                                      } else {
                                        const targetQuestion = groupBy(questions, 'jumpable_id')[jump];
                                        return(
                                          <div styleName="jump-form" key={index}>
                                            <div styleName="section-title">
                                              <span styleName="content">
                                                {Translate.get('answer_equals_to')} <span styleName="badge">{option.label}</span>
                                                {Translate.get('jump_to_question')} &nbsp;
                                                <span styleName="badge">
                                                  {targetQuestion ? targetQuestion[0].label : ''}
                                                </span>
                                              </span>
                                              <Button
                                                type="danger"
                                                size="small"
                                                onClick={() => {
                                                  confirm(Translate.get('are_you_sure')) ?
                                                    this.data.question_options[index].jump_ids.splice(jumpIndex, 1)
                                                  : ''
                                                  updateQuestion(data, `question_options[${index}].jump_ids`, this.data.question_options[index].jump_ids)
                                                }}>
                                                {Translate.get('remove')}
                                              </Button>
                                              &nbsp;
                                              <Button
                                                type="primary"
                                                size="small"
                                                onClick={() => updateQuestion(data, 'active_jump', [index, jumpIndex])}>
                                                {Translate.get('edit')}
                                              </Button>
                                            </div>
                                          </div>
                                        )
                                      }
                                    }
                                  })
                                ))
                              }
                              {
                                this.state.addNewLogicalJump ?
                                  <div styleName="jump-form">
                                    <div styleName="form-content">
                                      {Translate.get('answer_equals_to')}
                                      <Select
                                        options={this.data.question_options.map((option, index) => (
                                          { label: option.label, value: index }
                                        ))}
                                        onChange={val => {
                                          this.setState({ jumpFrom: val })
                                        }}
                                        id="inline-select"
                                      />
                                      {Translate.get('jump_to_question')}
                                      <Select
                                        options={questions.map((question, index) => (
                                          { label: `${index+1} - ${question.label}`, value: question.jumpable_id, disabled: this.state.jumpFrom !== null ? index <= order - 1 : true }
                                        ))}
                                        onChange={val => {
                                          if (this.state.jumpFrom !== null && val !== null) {
                                            const existingJumps = this.data.question_options[this.state.jumpFrom].jump_ids;
                                            updateQuestion(data, `question_options[${this.state.jumpFrom}].jump_ids`, [...existingJumps, val]);
                                            this.setState({ addNewLogicalJump: false, jumpFrom: null });
                                          }
                                        }}
                                        id="inline-select"
                                        disabled
                                      />
                                    </div>
                                  </div>
                                : ''
                              }
                              <Button size="small" type="weak" style={{ textAlign: 'left' }} onClick={() => this.setState({ addNewLogicalJump: true })}>
                                + {Translate.get('add_logical_jump')}
                              </Button>
                            </div>
                          : ''
                        }
                      </div>
                    : ''
                  }
                  <QuestionType data={data}/>
                </CardContent>
              : ''
            }
          </Card>
          <Gallery
            images={this.state.media}
            lightboxIsOpen={this.state.lightboxIsOpen}
            customMedia={this.state.customMedia}
            currentImage={0}
            onClose={() => this.setState({ lightboxIsOpen: false })}
          />
        </div>
        {addNewElement}
      </div>
    ) : null
  }
}

Element = connect(
  state => {
    return {
      questions: state.form.taskForm ? state.form.taskForm.values.questions.filter( item => item._destroy !== true ) : []
    }
  },
  {
    updateQuestion: (question, field, value) => change('taskForm', `${question}.${field}`, value)
  }
)(Element)

export default Element



// WEBPACK FOOTER //
// ./src/components/task-form/element.js